import { Check } from "@clockwise/icons";
import { Menu } from "@headlessui/react";
import { SvgIcon } from "@material-ui/core";
import classNames from "classnames";
import { isUndefined } from "lodash";
import React from "react";

type Props = {
  checked?: boolean;
  onClick?: () => void;
};

export const DropDownMenuItem: React.FC<Props> = ({ checked, children, onClick }) => {
  const checkable = !isUndefined(checked);
  const CheckedIcon = checked ? Check : SvgIcon;

  return (
    <Menu.Item>
      {({ active }) => (
        <div
          {...(checkable ? { "aria-checked": checked } : {})}
          className={classNames(
            {
              "cw-bg-neutral-inset": active,
            },
            "cw-text-default cw-cursor-pointer",
            "cw-select-none cw-relative cw-px-2 cw-py-[5px] cw-rounded-lg cw-bg-default cw-border-none cw-w-full",
            "cw-text-sm",
          )}
          onClick={onClick}
        >
          <div className="cw-flex cw-items-center">
            {checkable && <CheckedIcon className="cw-text-positive cw-mr-2 cw-text-sm" />}
            {children}
          </div>
        </div>
      )}
    </Menu.Item>
  );
};

type DropDownMenuLinkItemProps = {
  href: string;
};

export const DropDownMenuLinkItem: React.FC<DropDownMenuLinkItemProps> = ({ children, href }) => {
  return (
    <Menu.Item>
      {({ active }) => (
        <div
          className={classNames(
            {
              "cw-bg-neutral-inset": active,
            },
            "cw-text-default cw-cursor-pointer",
            "cw-select-none cw-relative cw-px-2 cw-py-[5px] cw-rounded-lg cw-bg-default cw-border-none cw-w-full",
            "cw-text-sm",
          )}
        >
          <div className="cw-flex cw-items-center">
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="cw-no-underline cw-text-default cw-w-full"
            >
              {children}
            </a>
          </div>
        </div>
      )}
    </Menu.Item>
  );
};

type DropDownMenuClickItemProps = {
  disabled?: boolean;
  keepOpen?: boolean;
  onClick?: () => void;
};

export const DropDownMenuClickItem: React.FC<DropDownMenuClickItemProps> = ({
  children,
  disabled = false,
  onClick,
  keepOpen = false,
}) => {
  const handleClick: React.MouseEventHandler<HTMLDivElement> = (event) => {
    // DevNote: https://github.com/tailwindlabs/headlessui/discussions/1122
    if (disabled) {
      return;
    }

    onClick?.();

    if (keepOpen) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Menu.Item disabled={disabled}>
      {({ active }) => (
        <div
          onClick={handleClick}
          className={classNames(
            {
              "cw-bg-neutral-inset": active,
            },
            "cw-text-default cw-cursor-pointer",
            "cw-select-none cw-relative cw-px-2 cw-py-[5px] cw-rounded-lg cw-bg-default cw-border-none cw-w-full",
            "cw-text-sm",
          )}
        >
          <div className="cw-flex cw-items-center">{children}</div>
        </div>
      )}
    </Menu.Item>
  );
};
